import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Breadcrumbs from '../navigation/Breadcrumbs';
import { buildServiceBreadcrumbs } from '../navigation/breadcrumbUtils';
import './UIUXDesign.css';

const UIUXDesign = () => {
  const location = useLocation();
  const servicesIndexView = location.state?.servicesIndexView;
  const backPath = servicesIndexView ? '/services' : '/';

  return (
    <div className="ui-ux-design-page-wrapper">
      <div className="ui-ux-design-page-container">
        <Breadcrumbs
          items={buildServiceBreadcrumbs('services', 'UI/UX Design')}
        />

        <div className="ui-ux-design-back-link">
          <Link
            to={backPath}
            state={servicesIndexView ? { servicesIndexView } : undefined}
          >
            {servicesIndexView ? '\u2190 Back' : '\u2190 Back to Home'}
          </Link>
        </div>

        <div className="ui-ux-design-page-hero">
          <h1>UI/UX Design Services</h1>
          <p>
            BlackRoth delivers user-centric UI/UX Design services that create
            intuitive, engaging, and scalable digital experiences aligned
            with business goals and user expectations.
          </p>
        </div>

        <section className="ui-ux-design-page-section">
          <h2>Overview</h2>
          <p>
            UI/UX design plays a critical role in product success. BlackRoth
            focuses on understanding users, business objectives, and
            technology constraints to design experiences that are both
            visually appealing and functionally effective.
          </p>
        </section>

        <section className="ui-ux-design-page-section">
          <h2>Core Capabilities</h2>
          <p>
            Our UI/UX solutions combine research-driven insights with modern
            design principles to deliver seamless user journeys across web,
            mobile, and enterprise platforms.
          </p>
        </section>

        <section className="ui-ux-design-page-section">
          <h2>Services We Offer</h2>
          <ul className="ui-ux-design-service-list">
            <li>User Research & Requirement Analysis</li>
            <li>Information Architecture & User Flows</li>
            <li>Wireframing & Interactive Prototyping</li>
            <li>UI Design for Web & Mobile Applications</li>
            <li>UX Audits & Usability Testing</li>
            <li>Design Systems & Style Guides</li>
            <li>Accessibility & Inclusive Design</li>
            <li>Design-to-Development Handoff</li>
          </ul>
        </section>

        <section className="ui-ux-design-page-section">
          <h2>Industry Use Cases</h2>
          <p>
            BlackRoth's UI/UX Design services support startups, enterprises,
            SaaS platforms, e-commerce, fintech, healthcare, and internal
            enterprise systems by improving usability and user satisfaction.
          </p>
        </section>

        <section className="ui-ux-design-page-section">
          <h2>Design Tools & Process</h2>
          <p>
            We work with industry-standard design tools and frameworks
            including Figma, Adobe XD, Sketch, and modern UI frameworks,
            following agile and collaborative design processes.
          </p>
        </section>

        <section className="ui-ux-design-page-section">
          <h2>Quality & Consistency</h2>
          <p>
            BlackRoth ensures design consistency, usability, and scalability
            by adhering to best practices, accessibility standards, and
            continuous feedback throughout the design lifecycle.
          </p>
        </section>
      </div>
    </div>
  );
};

export default UIUXDesign;

